import Error from "next/error"
import { CONSTANTS } from "../config/Constants"

function Custom404() {
    return <Error statusCode={404} title={CONSTANTS[404]} withDarkMode={false} />
}


export default Custom404